import React from 'react';
import {getStandardsBodyRelated} from 'api/standards';
import {SelectSearchBase} from 'components/Forms/FormBases';

class SelectStandardsBodyRelated extends React.Component {
  static defaultProps = {
    isClearable: true,
    cacheOptions: true,
    defaultOptions: true, // load default options
    isDisabled: false,
    name: 'standards_id',
    placeholder: 'Select a Standard',
    filters: {},
    onChange: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      options: [],
      value: props.defaultValue || '',
      inputValue: '',
    };
  }

  componentDidMount() {
    this._isMounted = true;

    const {defaultOptions} = this.props;

    if (defaultOptions) this.loadOptions();
  }

  componentDidUpdate(prevProps, prevState) {
    const {inputValue} = this.state;
    const {accreditation_bodies_id, certification_bodies_id} =
      this.props.filters;

    if (
      prevProps.filters.accreditation_bodies_id !== accreditation_bodies_id ||
      prevProps.filters.certification_bodies_id !== certification_bodies_id
    ) {
      this.setState(
        {
          value: '',
          options: [],
        },
        this.loadOptions
      );
    }

    if (prevState.inputValue !== inputValue) {
      this.loadOptions();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadOptions = async () => {
    const {isDisabled, filters} = this.props;

    if (isDisabled) return false;

    if (!filters.accreditation_bodies_id || !filters.certification_bodies_id) {
      return false;
    }

    await this.setState({isLoading: true});

    const {inputValue} = this.state;
    const response = await getStandardsBodyRelated({
      ...filters,
      search: inputValue,
      order: 'ASC',
      order_by: 'standards_code',
    });

    if (!this._isMounted) return false; // Check Mounted

    this.setState({
      options: response.data,
      isLoading: false,
    });
  };

  render() {
    const {value, defaultOptions, filters, onChange, ...rest} = this.props;

    return (
      <SelectSearchBase
        value={this.state.value}
        options={this.state.options}
        isLoading={this.state.isLoading}
        getOptionLabel={(option) => option.standards_name}
        getOptionValue={(option) => option.standards_id}
        onChange={(data) => this.setState({value: data}, onChange(data))}
        onInputChange={(value) => this.setState({inputValue: value})}
        {...rest}
      />
    );
  }
}

export default SelectStandardsBodyRelated;
